import {Object3D} from '@wonderlandengine/api';

export class Particle {
    isAlive = true;
    private _age = 0;

    /**
     * Returns the progress of the particle's life in the range [0, 1]
     */
    get lifeProgress() {
        return this._age / this.lifetime;
    }

    constructor(
        public lifetime: number,
        public object: Object3D,
        public angularVelocity: number = 0,
        public currentRotation: number = 0
    ) {}

    update(dt: number) {
        this._age += dt;
        if (this._age >= this.lifetime) {
            this.isAlive = false;
            return;
        }
    }
}
